module.exports = __webpack_public_path__ + "static/img/home34.4617b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/home34.png
// module id = Tl3S
// module chunks = 0